import { Box, FluidImage, Icon, SelectionSetLabel, Typography } from '@vp/swan';
import { GridChoiceProps } from './GridChoiceField';
import isSwanIconKey from './isSwanIconKey';

export default function GridChoiceTile(props: GridChoiceProps) {
    const { image, label, isViewOnly = false, description } = props;
    return (
        <SelectionSetLabel
            style={{
                overflow: 'hidden',
                width: '100%',
                maxWidth: '154px',
                minWidth: '100px',
                alignItems: 'flex-start',
                minHeight: '96px',
                height: '100%',
                pointerEvents: isViewOnly ? 'none' : undefined,
                ...(isSwanIconKey(image) && isViewOnly ? { justifyContent: 'center' } : {}),
            }}
        >
            {isSwanIconKey(image) ? (
                <Icon iconType={image} margin={5} size="standard" />
            ) : (
                image && (
                    <FluidImage
                        src={image}
                        alt={label}
                        paddingTop={4}
                        paddingBottom={3}
                        paddingX={4}
                        style={{
                            objectFit: 'cover',
                            width: '80%',
                            height: '80%',
                            minHeight: '64px',
                            objectPosition: 'left',
                        }}
                    />
                )
            )}

            <Box
                textAlign="left"
                paddingLeft={5}
                paddingRight={3}
                paddingBottom={5}
                style={{ width: '100%' }}
            >
                <Typography fontWeight="bold">{label}</Typography>
                {description && <Typography fontSkin="body-small">{description}</Typography>}
            </Box>
        </SelectionSetLabel>
    );
}
